export const maxItemNameLength = 200
export const minItemNameLength = 3
